import React from 'react';
import { Dialog } from '@economic/taco';
import { Trans } from '@lingui/macro';
import { Link } from 'react-router-dom';
import imgSupportPerson from '~/app/pages/market/onboarding/CustomerPayments/assets/support-man-dark-monitor.png';

const OnboardingFailed = () => {
    return (
        <>
            <Dialog.Title>
                <Trans>Sorry, we cannot offer the service at this time</Trans>
            </Dialog.Title>

            <div className="flex mt-6 justify-center">
                <img src={imgSupportPerson} alt="" />
            </div>

            <div className="flex flex-col mt-8">
                <strong>
                    <Trans>We're always here to help</Trans>
                </strong>
                <Trans>Please contact the e-conomics support team for help to continue at this point</Trans>
            </div>

            <div className="flex flex-col mt-8">
                <strong>
                    <Trans>E-mail:</Trans>
                </strong>
                <Link to="mailto:info@e-conomic.dk">
                    <Trans>info@e-conomic.dk</Trans>
                </Link>
            </div>

            <div className="flex flex-col mt-8">
                <strong>
                    <Trans>Phone number:</Trans>
                </strong>
                <Trans>+45 88 20 48 40</Trans>
            </div>
        </>
    );
};

export default OnboardingFailed;
